const initialState = {
  byWidgetId: {},
};

const omerReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'FETCH_OMER_START': {
      const { widgetId } = action.payload;
      return {
        ...state,
        byWidgetId: {
          ...state.byWidgetId,
          [widgetId]: {
            ...(state.byWidgetId[widgetId] || {}),
            loading: true,
            error: null,
          },
        },
      };
    }
    case 'FETCH_OMER_SUCCESS': {
      const { widgetId, data } = action.payload;
      return {
        ...state,
        byWidgetId: {
          ...state.byWidgetId,
          [widgetId]: { loading: false, error: null, data },
        },
      };
    }
    case 'FETCH_OMER_FAILURE': {
      const { widgetId, error } = action.payload;
      return {
        ...state,
        byWidgetId: {
          ...state.byWidgetId,
          [widgetId]: {
            ...(state.byWidgetId[widgetId] || {}),
            loading: false,
            error,
          },
        },
      };
    }
    default:
      return state;
  }
};

export default omerReducer;
